const riot = require('riot');

riot.tag2('page-admin-paypay_maintenances-single', '<div class="s-full f"> <div data-is="module-sidebar"></div> <div class="s-full p40 bg-gray_light_10"> <div if="{!isLoading}"> <div class="mb20"><a class="f fm text-gray_dark_20 mb2" href="/admin/paypay_maintenances"><i class="material-icons">navigate_before</i> <div class="ts-h5">PayPayメンテナンス一覧</div></a> <div class="ts-h2">PayPayメンテナンスの{paypayMaintenanceSchedule ? \'編集\' : \'新規作成\'}</div> </div> <form class="p20 bg-white" onsubmit="{onSubmit}"> <div class="ts-h5 mb4">メンテナンス期間</div> <div class="f fm border-bottom border-gray_light_10 pb20 mb20"> <div class="f fm mr16"> <input class="input size-s border-gray mr8" ref="start_date" riot-value="{dayjs(paypayMaintenanceSchedule.start_at).format(&quot;YYYY-MM-DD&quot;)}" required type="{\'date\'}"> <input class="input size-s border-gray" ref="start_time" riot-value="{dayjs(paypayMaintenanceSchedule.start_at).format(&quot;HH:mm&quot;)}" required type="{\'time\'}"> </div> <div class="mr16">~</div> <div class="f fm"> <input class="input size-s border-gray mr8" ref="end_date" riot-value="{dayjs(paypayMaintenanceSchedule.end_at).format(&quot;YYYY-MM-DD&quot;)}" required type="{\'date\'}"> <input class="input size-s border-gray" ref="end_time" riot-value="{dayjs(paypayMaintenanceSchedule.end_at).format(&quot;HH:mm&quot;)}" required type="{\'time\'}"> </div> </div> <div class="f fr"> <button class="button danger mr8" if="{paypayMaintenanceSchedule}" type="button" onclick="{delete}">削除</button> <button class="button primary">保存</button> </div> </form> </div> </div> </div>', 'page-admin-paypay_maintenances-single,[data-is="page-admin-paypay_maintenances-single"]{display:block}', '', function(opts) {
    this.preload = async ({req, res}) => {
      this.isLoading = true;
      this.update();
      var id = req.params.id;

      if (id === 'new') {
        this.isLoading = false;
        this.update();
        return;
      }

      var { paypay_maintenance_schedule }= await app.api.child(`paypay_maintenance_schedules/${id}`).get();
      this.paypayMaintenanceSchedule = paypay_maintenance_schedule;
      this.isLoading = false;
      this.update();
    };

    this.onSubmit = async (e) => {
      e.preventDefault();
      try {
        var indicator = spat.modal.indicator();
        var start_at = dayjs(`${this.refs.start_date.value} ${this.refs.start_time.value}`).valueOf();
        var end_at = dayjs(`${this.refs.end_date.value} ${this.refs.end_time.value}`).valueOf();
        var query = {
          start_at,
          end_at,
        };

        if (this.paypayMaintenanceSchedule) {
          await app.api.child(`paypay_maintenance_schedules/${this.paypayMaintenanceSchedule.id}`).put(query);
        }

        else {
          await app.api.child('paypay_maintenance_schedules').post(query);
        }
        spat.modal.alert('保存しました');
        spat.router.push('/admin/paypay_maintenances');
      }
      catch (e) {
        console.error(e);
        spat.modal.alert(e.message);
      }
      finally {
        indicator.close();
      }
    };

    this.delete = async () => {
      var result = await app.utils.openModalDialog(
        {
          title: 'PayPayメンテナンスを削除',
          text: '本当にPayPayメンテナンスを削除しますか？この操作は取り消すことができません。',
          danger: true,
          positive: '削除',
          size: 'medium',
        }
      );
      if (!result) return;
      var indicator = spat.modal.indicator();
      try {
        await app.api.child(`paypay_maintenance_schedules/${this.paypayMaintenanceSchedule.id}`).del({});
        spat.modal.alert('削除しました');
        spat.router.push('/admin/paypay_maintenances');

      }
      catch (e) {
        console.error(e);
        spat.modal.alert(e.message);
      }
      finally {
        indicator.close();
      }
    };
});